const singularRoles = ["CEO", "CTO", "CMO", "CFO"];
export const articleForRoleTitle = (title: string): string =>
  singularRoles.includes(title) ? "the" : "a";

export default articleForRoleTitle;
